
import { Component, Prop, Vue } from 'vue-property-decorator';
import RoleRepository from '@/services/Roles';
import UsersRepo from '@/services/Users';
import { RoleInterface } from '@/services/Roles/Interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { UserResponseInterface } from '@/services/Users/Interfaces';
import { EditUserForm } from '@/services/Users/forms/EditUserForm';
import DepartmentRepository from '@/services/Departments';
import { DepartmentInterface } from '@/services/Departments/Interfaces';

@Component({
  inject: [
    'userRepository',
    'rolesRepository',
    'departmentRepository',
  ],
})
export default class EditUserAuth extends Vue {
  private readonly userRepository!: UsersRepo;
  private readonly rolesRepository!: RoleRepository;
  private readonly departmentRepository!: DepartmentRepository;

  @Prop() private readonly userId: string;

  private user: Partial<UserResponseInterface> = {
    _id: '',
    username: '',
    name: '',
    deletedAt: '',
    email: '',
    role: undefined,
    department: {} as DepartmentInterface,
  };

  private loading: boolean = true;
  private roles: RoleInterface[] = [];
  private departments: DepartmentInterface[] = [];

  private form: WPXFormValue<EditUserForm> = new WPXFormValue(EditUserForm);

  private async created(): Promise<void> {
    if (!this.userId) {
      await this.$router.push({ name: 'users_index' });
      this.$notifications.error('UserId not provided');

      return;
    }

    try {
      const departments = await this.departmentRepository.getAllDepartments();

      departments.map((department: DepartmentInterface) => {
        this.departments.push(department);
      });

      this.user = await this.userRepository.getUser(this.userId);
      this.form.data.username = String(this.user.username);
      this.form.data.email = String(this.user.email);
      this.form.data.department = this.user.department ? this.user.department._id : '';
      await this.updateRoleField();
      this.form.data.role = String(this.user.role?._id);
    } catch (e) {
      console.error(e);
    }

    this.loading = false;
  }

  private async updateRoleField(): Promise<void> {
    if (!this.form.data.department) {
      return;
    }

    const selectedDepartment = this.form.data.department;
    const roles = await this.rolesRepository.getAllByDepartment(selectedDepartment);
    this.roles = [];

    roles.map((role: RoleInterface) => {
      if (role.department) {
        this.roles.push({
          id: role.id,
          name: role.name,
          scopes: [],
          permissions: [],
          department: role.department,
        });
      }
    });
  }

  private async editUser(): Promise<void> {
    try {
      await this.userRepository.editUser(String(this.user._id),
        {
          username: this.form.data.username,
          email: this.form.data.email,
          password: this.form.data.password,
          passwordConf: this.form.data.passwordConf,
          roleId: this.form.data.role,
          recreate: this.form.data.recreate,
          unlock: this.form.data.unlock,
          department: this.form.data.department,
        },
      );

      this.$successDialog.show(`User '${this.form.data.username}' has been edited`);
    } catch (err) {
      this.$errorDialog.show(err.response.data.error);
    }
  }
}
